// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const LIST_OF_FORUMS = "Zoznam diskusi\u00ed";
export const NEWEST_DISCUSSIONS = "Najnov\u0161ie diskusie";
export const SHORTENED_SEARCH_IN_FORUM = "H\u013eadaj v diskusi\u00e1ch...";
export const WHERE_ARE_DISCUSSIONS = "Kde sa pr\u00e1ve diskutuje";
